module.exports = __webpack_public_path__ + "static/corona-9ba614e47d4b2a5190d35ff543fd8a80.svg";